import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  unref,
  useLazyAsyncData,
  useNuxtApp,
  useRuntimeConfig,
} from '#app'
import { AjaxFetchTopDestinationsRepository } from '~/apps/top-destinations/AjaxFetchTopDestinationsRepository'
import { TopDestination } from '~/apps/top-destinations/schemas'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopDestinations',
  props: {
    destinations: null
  },
  setup(__props: any) {

const props = __props as {
  destinations?: TopDestination[]
};



const config = useRuntimeConfig()
const { $route } = useNuxtApp()
const fetchOptions = {
  ...config.axios,
  retry: 0,
  timeout: 10000,
}
const lang = $route.params.lang || 'en-gb'
const destinationsRepository = new AjaxFetchTopDestinationsRepository()

const { data: destinationsData } = props.destinations
  ? { data: props.destinations }
  : useLazyAsyncData(`destinations-${lang}`, async () => {
    return await destinationsRepository.getAll(lang, fetchOptions)
  })

const destinationsList = computed(() => unref(destinationsData))

return { __sfc: true,props, config, $route, fetchOptions, lang, destinationsRepository, destinationsData, destinationsList }
}

})